import { z } from 'zod';

export const UserAccountTypeValues = [
  'personal',
  'business',
  'employee_savings',
  'wm_personal',
  'wm_business',
] as const;
export type UserAccountType = (typeof UserAccountTypeValues)[number];
export const ZodUserAccountType = z.enum(UserAccountTypeValues);
